import type { Role } from '@customTypes/types';
import { useNavigate } from '@tanstack/react-router';

import { useCreateConversationMutation, useGetChatProfileQuery } from '../api';

export const useCreateOrGetConversation = ({
  senderProfileId,
  recipientProfileId,
  recipientProfileRole,
  senderProfileRole
}: {
  senderProfileId: string;
  senderProfileRole: Role;
  recipientProfileId: string;
  recipientProfileRole: Role;
}) => {
  const navigate = useNavigate();
  const createConversationMutation = useCreateConversationMutation();

  const senderProfile = useGetChatProfileQuery({
    profileId: senderProfileId,
    profileType: senderProfileRole
  });
  const recipientProfile = useGetChatProfileQuery(
    {
      profileId: recipientProfileId,
      profileType: recipientProfileRole
    },
    {
      options: {
        enabled: Boolean(senderProfile.data?.data?.chatProfileId)
      }
    }
  );

  const createConversation = async () => {
    if (
      recipientProfile.data?.data.chatProfileId &&
      senderProfile.data?.data.chatProfileId
    ) {
      await createConversationMutation.mutateAsync(
        {
          params: {
            recipientProfileId:
              recipientProfile.data?.data.chatProfileId.toString(),
            senderProfileId: senderProfile.data?.data.chatProfileId.toString()
          }
        },
        {
          onSuccess: (response) => {
            navigate({
              to: '/conversation/$conversationId',
              params: {
                conversationId: response.data.conversationId.toString()
              }
            });
          }
        }
      );
    }
  };

  return {
    createConversation
  };
};
